import SliderManager from "./sliderManager";

export default class LazySliderManager {

    constructor() {
        this.sliderManager = new SliderManager();
    }

    observeSliders(slidersSelector) {
        const slidersElements = document.querySelectorAll(slidersSelector);

        const intersectionObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const sliderElement = entry.target;

                    if (!sliderElement.classList.contains('swiper-initialized')) {
                        this.sliderManager.addSlider(sliderElement, null, 'bullets', 5);
                    }

                    observer.unobserve(sliderElement);
                }
            });
        }, {
            root: null,
            threshold: 0.1,
            rootMargin: "200px 0px"
        });

        slidersElements.forEach(slider => intersectionObserver.observe(slider));
    }
}
